import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/common/material-module';

@Component({
    selector: 'app-send-verification-dialog',
    imports: [MaterialModule],
    templateUrl: './send-verification-dialog.component.html',
    styleUrl: './send-verification-dialog.component.scss'
})
export class SendVerificationDialogComponent {
    constructor(
    public dialogRef: MatDialogRef<SendVerificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { hs_email: string, admin_email: string, quoteTarget: string }
  ) {}

  send() {
    this.dialogRef.close(true);
  }
}
